import { Moment } from 'moment';
import { EProvider } from '../Shared/enum/provider.enum';


export class Employee
{
    constructor()
    {
        this.usedBenefits = 0;
        this.selectedProvider = EProvider.none;
    }

   selectedProvider:EProvider;
   usedBenefits:number;
}